document.addEventListener('DOMContentLoaded', function() {

  //banner dimanico___
  
  const lang = document.querySelector('html');


  if(document.querySelector('#product-custom')){
    const getVendorText = document.querySelector('#product-custom .product-meta__vendor a').textContent;
  
    if(getVendorText === 'CARTEC - Colorline'){
      var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/Colorline.jpg?v=1664985786';
      var logoMarcaText = 'La linea dedicata al professionist';
      var titoloBannerText = 'CARTEC - COLORLINE';
      var descrizioneBannerText = 'Colorline è la linea di prodotti professionali di elevata qualità firmata Cartec. Colorline è specifica per la cura, la pulizia e il ripristino degli interni ed esterni dell’auto. Tutti i prodotti devono essere sottoposti a diluizione e sono, inoltre, sicuri su qualsiasi superficie.';
      var btnBannerText = 'VEDI I PRODOTTI COLORLINE';
      var btnBannerUrl = '/collections/cartec-colorline';
      if(lang == 'en'){
        var logoMarcaText = 'The line dedicated to professionals';
        var descrizioneBannerText = 'Colorline is Cartec’s high-quality professional product line. It is specifically designed for the care, cleaning, and restoration of both the interior and exterior of vehicles. All products must be diluted and are safe to use on any surface.';
        var btnBannerText = 'Discover all Colorline solutions';
        var btnBannerUrl = '/en/collections/cartec-colorline';
      }
    }
    else if(getVendorText.includes("CARPRO")){
      var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/CARPRO.jpg?v=1664986068';
      var logoMarcaText = 'Metti il turbo con CARPRO';
      var titoloBannerText = 'CARPRO';
      var descrizioneBannerText = 'CARPRO è il brand di riferimento per car care e care detailing che fornisce ogni tipo di soluzione per la cura dell’auto. Grazie alla qualità dei suoi prodotti e alla continua ricerca si contraddistingue per l’innovativa tecnologia e per l’essere un must per i detailers più esigenti.';
      var btnBannerText = 'VEDI I PRODOTTI CARPRO';
      var btnBannerUrl = '/collections/carpro';
      if(lang == 'en'){
        var logoMarcaText = 'Boost your detailing with CARPRO';
        var descrizioneBannerText = 'CARPRO is the go-to brand for car care and detailing, offering every type of solution for vehicle maintenance. Known for its product quality and constant innovation, CARPRO stands out for its cutting-edge technology and is a must-have for the most demanding detailers.';
        var btnBannerText = 'Discover all CARPRO solutions';
        var btnBannerUrl = '/en/collections/carpro';
      }
    }
    else if(getVendorText === 'CARTEC'){
      var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/Cartec.jpg?v=1664986261';
      var logoMarcaText = 'Performance professionali. Risultati garantiti.';
      var titoloBannerText = 'CARTEC';
      var descrizioneBannerText = "Cartec si occupa da oltre 35 anni della ricerca e dello sviluppo di prodotti per la pulizia, la protezione e la lucidatura di auto. Spinta dalla passione per l'innovazione, dalla ricerca della massima qualità e da un servizio personalizzato, Cartec è diventata uno dei maggiori fornitori di prodotti professionali per la cura dell'auto.";
      var btnBannerText = 'VEDI I PRODOTTI CARTEC';
      var btnBannerUrl = '/collections/cartec';
      if(lang == 'en'){
        var logoMarcaText = 'Professional performance. Guaranteed results.';
        var descrizioneBannerText = 'For over 35 years, Cartec has been dedicated to researching and developing products for cleaning, protecting, and polishing vehicles. Driven by passion for innovation, the pursuit of top quality, and personalized service, Cartec has become one of the leading suppliers of professional car care products.';
        var btnBannerText = 'Discover the Cartec range';
        var btnBannerUrl = '/en/collections/cartec';
      }
    }
    else if(getVendorText === 'ACTIVE PRODUCTS'){
      var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/Active_Products.jpg?v=1745392225';
      var logoMarcaText = 'L’energia giusta per ogni fase del lavaggio.';
      var titoloBannerText = 'ACTIVE PRODUCTS';
      var descrizioneBannerText = "La gamma Active è pensata per chi cerca potenza, efficienza e qualità negli strumenti per la pulizia dell’auto. Soluzioni innovative, robuste e progettate per garantire prestazioni professionali.";
      var btnBannerText = 'VEDI I PRODOTTI ACTIVE';
      var btnBannerUrl = '/collections/active-products';
      if(lang == 'en'){
        var logoMarcaText = 'The right power for every washing step.';
        var descrizioneBannerText = 'The Active range is designed for those looking for power, efficiency and quality in car cleaning tools. Innovative, robust solutions designed to ensure professional performance.';
        var btnBannerText = 'Discover the ACTIVE PRODUCTS range';
        var btnBannerUrl = '/en/collections/active-products';
      }
    }  
    else if(getVendorText === 'CARTEC - Essential'){
      var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/Essentials.jpg?v=1664986688';
      var logoMarcaText = 'La base per ogni appassionato';
      var titoloBannerText = 'CARTEC - ESSENTIAL';
      var descrizioneBannerText = 'Essentials è l’esclusiva linea per la cura dell’auto dedicata all’appassionato più esigente dotata dei migliori prodotti per pulizia, lavaggio, protezione e finitura di interni ed esterni.';
      var btnBannerText = 'VEDI I PRODOTTI ESSENTIAL';
      var btnBannerUrl = '/collections/cartec-essentials';
      if(lang == 'en'){
        var logoMarcaText = 'The foundation for every enthusiast';
        var descrizioneBannerText = 'Essentials is the exclusive car care line designed for the most passionate enthusiasts, offering top-quality products for cleaning, washing, protecting, and finishing both interiors and exteriors.';
        var btnBannerText = 'Discover the Essentials line';
        var btnBannerUrl = '/en/collections/cartec-essentials';
      }
    }
    else if(getVendorText === 'CARTEC - Refinish'){
      var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/Refinish.jpg?v=1664986770';
      var logoMarcaText = "Massime prestazioni in ogni fase della lucidatura";
      var titoloBannerText = 'CARTEC - REFINISH';
      var descrizioneBannerText = 'Refinish è il sistema di lucidatura Cartec che si distingue per innovazione e performance. Garantisce risultati eccezionali su qualsiasi tipo di vernice in massimo due step. Refinish conferisce ai colori maggiore profondità e brillantezza. Il sistema di lucidatura Refinish può essere utilizzato con lucidatrice rotativa e orbitale.';
      var btnBannerText = 'VEDI I PRODOTTI REFINISH';
      var btnBannerUrl = '/collections/cartec-refinish';
      if(lang == 'en'){
        var logoMarcaText = 'Maximum performance in every phase of polishing';
        var descrizioneBannerText = 'Refinish is Cartec’s polishing system that stands out for its innovation and performance. It delivers exceptional results on any type of paintwork in just two steps. Refinish enhances color depth and gloss. The system can be used with both rotary and orbital polishers.';
        var btnBannerText = 'Discover the Refinish line';
        var btnBannerUrl = '/en/collections/cartec-refinish';
      }
    }
    else if(getVendorText === 'CARTEC - Ceramic Guard'){
      var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/ceramic-guard.jpg?v=1673860341';
      var logoMarcaText = 'Nanotecnologia al tuo servizio';
      var titoloBannerText = 'CARTEC - CERAMIC GUARD';
      var descrizioneBannerText = 'Ceramic Guard è la linea di protettivi nanotecnologici per il detailer più evoluto che è sempre alla ricerca di performance grandiose in termini di protezione e gloss.';
      var btnBannerText = 'VEDI I PRODOTTI CERAMIC GUARD';
      var btnBannerUrl = '/collections/cartec-ceramic-guard';
      if(lang == 'en'){
        var logoMarcaText = 'Nanotechnology at your service';
        var descrizioneBannerText = 'Ceramic Guard is Cartec’s line of nanotech protective products for the most advanced detailers, always striving for outstanding performance in terms of protection and gloss.';
        var btnBannerText = 'Discover CERAMIC GUARD products';
        var btnBannerUrl = '/en/collections/cartec-ceramic-guard';
      }
    }
    else if(getVendorText === 'CARTEC - Royal Care'){
      var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/Royal_Care.jpg?v=1664987028';
      var logoMarcaText = 'Per un lavaggio Regale';
      var titoloBannerText = 'CARTEC - ROYAL CARE';
      var descrizioneBannerText = 'Royal Care è la linea firmata Cartec di prodotti per autolavaggio che supera le aspettative in tutte le fasi della pulizia esterna dell’auto, a partire dal prelavaggio, alla protezione della carrozzeria fino alla sua asciugatura.';
      var btnBannerText = 'VEDI I PRODOTTI ROYAL CARE';
      var btnBannerUrl = '/collections/cartec-royal-care';
      if(lang == 'en'){
        var logoMarcaText = 'For a royal finish';
        var descrizioneBannerText = 'Royal Care is Cartec’s premium car wash line that exceeds expectations in every phase of exterior vehicle cleaning — from pre-wash, to paint protection, all the way to drying.';
        var btnBannerText = 'Discover ROYAL CARE products';
        var btnBannerUrl = '/en/collections/cartec-royal-care';
      }
    }
    else if(getVendorText === 'CARISMATIX'){
      var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/CARISMATIX_Brand.jpg?v=1751293337';
      var logoMarcaText = 'Efficienza, controllo e massima affidabilità';
      var titoloBannerText = 'CARISMATIX';
      var descrizioneBannerText = 'CARISMATIX è il marchio italiano nato dalla passione per il Detailing e il Refinish. Coniuga esperienza sul campo e continua ricerca, per offrire una linea di prodotti e accessori ad alte prestazioni. Dall’estetica curata alla funzionalità concreta, ogni articolo Carismatix è pensato per valorizzare il lavoro degli operatori del settore e degli appassionati più esigenti.';
      var btnBannerText = 'VEDI I PRODOTTI CARISMATIX';
      var btnBannerUrl = '/collections/carisamtix';
      if(lang == 'en'){
        var logoMarcaText = 'Efficiency, control and reliability';
        var descrizioneBannerText = 'CARISMATIX is the Italian brand born from the passion for Detailing and Refinish. Combines field experience and continuous research, to offer a line of high performance products and accessories. From careful aesthetics to concrete functionality, each Carismatix article is designed to enhance the work of professionals in the sector and the most demanding enthusiasts.';
        var btnBannerText = 'Discover CARISMATIX products';
        var btnBannerUrl = '/en/collections/carismatix';
      }
    }


    /*
    else if(getVendorText === 'KOCH-CHEMIE'){
      var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/Koch-Chemie.jpg?v=1741252489';
      var logoMarcaText = 'Per chi punta solo al meglio';
      var titoloBannerText = 'KOCH-CHEMIE';
      var descrizioneBannerText = "Marchio tedesco di riferimento nel Car Care dal 1968. Si distingue per l'attenzione ai dettagli e l'innovazione continua, offrendo soluzioni complete per la cura e la manutenzione di veicoli e imbarcazioni.";
      var btnBannerText = 'VEDI I PRODOTTI KOCH-CHEMIE';
      var btnBannerUrl = '/collections/koch-chemie';
          if(lang == 'en'){
        var logoMarcaText = 'For those who aim only at the best';
        var descrizioneBannerText = 'German reference brand in Car Care since 1968. Stands out for its attention to detail and continuous innovation, offering complete solutions for the care and maintenance of vehicles and boats.';
        var btnBannerText = 'Discover KOCH-CHEMIE products';
        var btnBannerUrl = '/en/collections/koch-chemie';
      }
    }
    */

else if(getVendorText === 'KOCH-CHEMIE'){
    var prodottoColurlock = document.querySelector('.COLOURLOCK');
    if (prodottoColurlock) {
        console.log('COLOURLOCK');
        var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/Colourlock.jpg?v=1748527362';
        var logoMarcaText = 'PER UNA PELLE SEMPRE COME NUOVA';
        var titoloBannerText = 'COLOURLOCK';
        var descrizioneBannerText = "Azienda tedesca leader nella pulizia, riparazione e protezione della pelle. COLOURLOCK sviluppa soluzioni specifiche per superfici in pelle, utilizzate dai migliori professionisti del settore per risultati impeccabili e duraturi.";
        var btnBannerText = 'VEDI I PRODOTTI COLOURLOCK';
        var btnBannerUrl = '/collections/colourlock';
        if(lang == 'en'){
            var logoMarcaText = 'FOR A LEATHER ALWAYS AS NEW';
            var descrizioneBannerText = 'Leading German company in cleaning, repair and leather protection. COLOURLOCK develops specific solutions for leather surfaces, used by the best professionals in the sector for flawless and long-lasting results.';
            var btnBannerText = 'Discover COLOURLOCK products';
            var btnBannerUrl = '/en/collections/colourlock';
        }
    }
    else {
        var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/Koch-Chemie.jpg?v=1741252489';
        var logoMarcaText = 'Per chi punta solo al meglio';
        var titoloBannerText = 'KOCH-CHEMIE';
        var descrizioneBannerText = "Marchio tedesco di riferimento nel Car Care dal 1968. Si distingue per l'attenzione ai dettagli e l'innovazione continua, offrendo soluzioni complete per la cura e la manutenzione di veicoli e imbarcazioni.";
        var btnBannerText = 'VEDI I PRODOTTI KOCH-CHEMIE';
        var btnBannerUrl = '/collections/koch-chemie';
        if(lang == 'en'){
            var logoMarcaText = 'For those who aim only at the best';
            var descrizioneBannerText = 'German reference brand in Car Care since 1968. Stands out for its attention to detail and continuous innovation, offering complete solutions for the care and maintenance of vehicles and boats.';
            var btnBannerText = 'Discover KOCH-CHEMIE products';
            var btnBannerUrl = '/en/collections/koch-chemie';    
        }   
    }
}
else if(getVendorText === 'COLOURLOCK'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/Colourlock_1.jpg?v=1749646434';
    var logoMarcaText = 'PER UNA PELLE SEMPRE COME NUOVA';
        var titoloBannerText = 'COLOURLOCK';
        var descrizioneBannerText = "Azienda tedesca leader nella pulizia, riparazione e protezione della pelle. COLOURLOCK sviluppa soluzioni specifiche per superfici in pelle, utilizzate dai migliori professionisti del settore per risultati impeccabili e duraturi.";
        var btnBannerText = 'VEDI I PRODOTTI COLOURLOCK';
        var btnBannerUrl = '/collections/colourlock';
        if(lang == 'en'){
            var logoMarcaText = 'FOR A LEATHER ALWAYS AS NEW';
            var descrizioneBannerText = 'Leading German company in cleaning, repair and leather protection. COLOURLOCK develops specific solutions for leather surfaces, used by the best professionals in the sector for flawless and long-lasting results.';
            var btnBannerText = 'Discover COLOURLOCK products';
            var btnBannerUrl = '/en/collections/colourlock';
    }
}

else if(getVendorText === 'Scangrip'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/Scangrip.jpg?v=1664987444';
    var logoMarcaText = "Illumina ogni dettaglio";
    var titoloBannerText = 'SCANGRIP';
    var descrizioneBannerText = 'Scangrip è l’azienda di riferimento per sistemi di illuminazione professionali dedicata a detailing e refinish. Nella sua gamma prodotti rientrano le luci a Led, progettate per soddisfare le esigenze del detailer più evoluto, e le UV Curing, specifiche per la polimerizzazione della vernice.';
    var btnBannerText = 'VEDI I PRODOTTI SCANGRIP';
    var btnBannerUrl = '/collections/scangrip';
    if(lang == 'en'){
    var logoMarcaText = 'Illuminates every detail';
    var descrizioneBannerText = 'Scangrip is the go-to company for professional lighting systems dedicated to detailing and refinishing. Its product range includes LED lights designed to meet the needs of the most advanced detailers, as well as UV Curing lights, ideal for paint curing.';
    var btnBannerText = 'Discover SCANGRIP products';
    var btnBannerUrl = '/en/collections/scangrip';
    }
}
else if(getVendorText === 'Scangrip - Color Match'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/Scangrip.jpg?v=1664987444';
    var logoMarcaText = 'La luce dei veri professionisti';
    var titoloBannerText = 'SCANGRIP - COLOR MATCH';
    var descrizioneBannerText = "La linea Colormatch di Scangrip rappresenta il massimo in termini di innovazione e tecnologia per l'individuazione del punto tinta, per l'analisi dei difetti presenti sulla superficie e per l'applicazione dei protettivi nanotecnologici.";
    var btnBannerText = 'VEDI I PRODOTTI SCANGRIP - COLOR MATCH';
    var btnBannerUrl = '/collections/scangrip-color-match';
    if(lang == 'en'){
    var logoMarcaText = 'The light of true professionals';
    var descrizioneBannerText = 'Scangrip’s Colormatch line represents the pinnacle of innovation and technology for color matching, surface defect analysis, and the application of nanotech protective coatings.';
    var btnBannerText = 'Discover SCANGRIP COLOR MATCH';
    var btnBannerUrl = '/en/collections/scangrip-color-match';
    }
}
else if(getVendorText === 'Scangrip - UV Curing'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/Scangrip.jpg?v=1664987444';
    var logoMarcaText = 'Alta tecnologia per cicli di lavoro più veloci';
    var titoloBannerText = 'SCANGRIP - UV CURING';
    var descrizioneBannerText = "La linea UV Curing di Scangrip offre una gamma di luci a LED completa e potente per la polimerizzazione UV. I prodotti UV si contraddistinguono per l’elevata efficienza del ciclo di lavoro combinata con l’effettivo risparmio energetico.";
    var btnBannerText = 'VEDI I PRODOTTI SCANGRIP - UV CURING';
    var btnBannerUrl = '/collections/scangrip-uv-curing';
    if(lang == 'en'){
    var logoMarcaText = 'High technology for faster work cycles';
    var descrizioneBannerText = 'Scangrip’s UV Curing line offers a complete and powerful range of LED lights for UV curing. These UV products stand out for their high work cycle efficiency combined with real energy savings.';
    var btnBannerText = 'Discover SCANGRIP UV CURING';
    var btnBannerUrl = '/en/collections/scangrip-uv-curing';
    }
}
else if(getVendorText === 'Scangrip - Work Ligths'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/Scangrip.jpg?v=1664987444';
    var logoMarcaText = 'Robuste, versatili, potenti';
    var titoloBannerText = 'SCANGRIP - WORK LIGHTS';
    var descrizioneBannerText = "Le luci da lavoro Scangrip sono estremamente resistenti e durature. Dotate della più recente tecnologia LED e del design funzionale e robusto, offrono una luce da lavoro ideale.";
    var btnBannerText = 'VEDI I PRODOTTI SCANGRIP - WORK LIGHTS';
    var btnBannerUrl = '/collections/scangrip-work-lights';
    if(lang == 'en'){
    var logoMarcaText = 'Robust, versatile, powerful';
    var descrizioneBannerText = 'Scangrip’s work lights are extremely durable and resistant. Equipped with the latest LED technology and a functional, rugged design, they provide the ideal work light for any task.';
    var btnBannerText = 'Discover SCANGRIP WORK LIGHTS';
    var btnBannerUrl = '/en/collections/scangrip-work-lights';
    }
}
else if(getVendorText === 'IK Sprayers'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/IK.jpg?v=1664987609';
    var logoMarcaText = 'Da esperti per esperti';
    var titoloBannerText = 'IK SPRAYERS';
    var descrizioneBannerText = 'IK Sprayers è il marchio di nebulizzatori professionali del Gruppo Goizper, rivolto ai professionisti e privati che cercano un prodotto efficace e di qualità indiscussa.';
    var btnBannerText = 'VEDI I PRODOTTI IK SPRAYERS';
    var btnBannerUrl = '/collections/ik-sprayers';
    if(lang == 'en'){
    var logoMarcaText = 'By experts for experts';
    var descrizioneBannerText = 'IK Sprayers is the professional sprayer brand from the Goizper Group, designed for both professionals and private users seeking an effective product with proven, top-tier quality.';
    var btnBannerText = 'Discover IK SPRAYERS products';
    var btnBannerUrl = '/en/collections/ik-sprayers';
    }
}
else if(getVendorText === 'Nexdiag'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/NexDiag.jpg?v=1664987715';
    var logoMarcaText = 'Tecnologia smart per misurazioni di precisione';
    var titoloBannerText = 'NEXDIAG';
    var descrizioneBannerText = 'NexDiag è specializzata nello sviluppo di sistemi evoluti di misurazione dello spessore della vernice dell’auto il cui segno distintivo è una visione innovativa dell’industria automobilistica. Grazie alla tecnologia sviluppata gli spessimetri NexDiag si distinguono per affidabilità e precisione, sia su superfici in alluminio che ferro.';
    var btnBannerText = 'VEDI I PRODOTTI NEXDIAG';
    var btnBannerUrl = '/collections/nexdiag';
    if(lang == 'en'){
    var logoMarcaText = 'Smart technology for precision measurements';
    var descrizioneBannerText = 'NexDiag specializes in the development of advanced paint thickness measurement systems for vehicles, defined by an innovative vision of the automotive industry. Thanks to its proprietary technology, NexDiag thickness gauges stand out for their reliability and precision, both on aluminum and steel surfaces.';
    var btnBannerText = 'Discover NEXDIAG products';
    var btnBannerUrl = '/en/collections/nexdiag';
    }
}
else if(getVendorText === 'Q1 Tapes'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/Q1.jpg?v=1664987787';
    var logoMarcaText = 'La Mascheratura resa semplice';
    var titoloBannerText = 'Q1 TAPES';
    var descrizioneBannerText = 'Q1 Tapes è specializzata nello sviluppo e nella produzione di soluzioni per mascheratura premium per il mercato aftermarket automotive, inclusa l’autocarrozzeria. Grazie a una gamma di elevata qualità offre una selezione completa tra cui nastri, film, carta e altri prodotti speciali.';
    var btnBannerText = 'VEDI I PRODOTTI Q1 TAPES';
    var btnBannerUrl = '/collections/q1-tapes';
    if(lang == 'en'){
    var logoMarcaText = 'Masking made simple';
    var descrizioneBannerText = 'Q1 Tapes specializes in developing and producing premium masking solutions for the automotive aftermarket, including body shops. Thanks to its high-quality range, it offers a complete selection of tapes, films, paper, and other specialty products.';
    var btnBannerText = 'Discover Q1 TAPES products';
    var btnBannerUrl = '/en/collections/q1-tapes';
    }
}
else if(getVendorText === 'Shinemate'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/ShineMate.jpg?v=1664987864';
    var logoMarcaText = 'Lucidatura professionale, senza compromessi';
    var titoloBannerText = 'SHINEMATE';
    var descrizioneBannerText = 'ShineMate è un marchio di proprietà della Pritronic, un colosso asiatico che produce lucidatrici, levigatrici ed accessori. I prodotti ShineMate sono i migliori ed i più potenti che si possono trovare sul mercato. Caratterizzati dall’ottimo rapporto qualità prezzo e dalla notevole resistenza e durata nel tempo, sono il meglio che un appassionato possa desiderare.';
    var btnBannerText = 'VEDI I PRODOTTI SHINEMATE';
    var btnBannerUrl = '/collections/shinemate';
    if(lang == 'en'){
    var logoMarcaText = 'Professional polishing, without compromise';
    var descrizioneBannerText = 'ShineMate is a brand owned by Pritronic, a major Asian company that produces polishers, sanders, and accessories. ShineMate products are among the best and most powerful on the market. Known for their excellent value, outstanding durability, and long-lasting performance, they’re the ultimate choice for any enthusiast.';
    var btnBannerText = 'Discover SHINEMATE products';
    var btnBannerUrl = '/en/collections/shinemate';
    }
}
else if(getVendorText === 'The Collection'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/The_Collection.jpg?v=1664987930';
    var logoMarcaText = 'Panni Premium';
    var titoloBannerText = 'THE COLLECTION';
    var descrizioneBannerText = "The Collection Microfiber è l'azienda tedesca produttrice di panni, guanti ed applicatori in microfibra. I suoi prodotti si contraddistinguono per l’ottimo rapporto qualità-prezzo e per le alte performance.";
    var btnBannerText = 'VEDI I PRODOTTI THE COLLECTION';
    var btnBannerUrl = '/collections/the-collection';
    if(lang == 'en'){
    var logoMarcaText = 'Premium cloths';
    var descrizioneBannerText = 'The Collection Microfiber is a German company that manufactures microfiber cloths, mitts, and applicators. Its products stand out for their excellent value for money and high performance';
    var btnBannerText = 'Discover THE COLLECTION products';
    var btnBannerUrl = '/en/collections/the-collection';
    }
}
else if(getVendorText === 'IDROBASE'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/IDROBASE.jpg?v=1664988069';
    var logoMarcaText = 'Potenza ad alta pressione per veri professionisti';
    var titoloBannerText = 'IDROBASE';
    var descrizioneBannerText = 'Idrobase Group propone soluzioni complete per il mondo della pulizia. Sistemi Aria Vortice di ottima fattura per cui propone anche un ampio catalogo di accessori e ricambi.';
    var btnBannerText = 'VEDI I PRODOTTI IDROBASE';
    var btnBannerUrl = '/collections/idrobase';
    if(lang == 'en'){
    var logoMarcaText = 'High-pressure power for true professionals';
    var descrizioneBannerText = 'Idrobase Group offers complete solutions for the cleaning world. Their high-quality “Aria Vortice” systems are Italian-made and backed by a wide catalog of accessories and spare parts.';
    var btnBannerText = 'Discover IDROBASE products';
    var btnBannerUrl = '/en/collections/idrobase';
    }
}
else if(getVendorText === 'MTM Hydro'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/MTM_Hydro.jpg?v=1664988114';
    var logoMarcaText = 'Foam, pressione e precisione';
    var titoloBannerText = 'MTM HYDRO';
    var descrizioneBannerText = "È un'azienda leader che da oltre 30 anni si pone come riferimento nella progettazione e produzione di componenti e accessori professionali per idropulitrici e autolavaggio.";
    var btnBannerText = 'VEDI I PRODOTTI MTM HYDRO';
    var btnBannerUrl = '/collections/mtm-hydro';
    if(lang == 'en'){
    var logoMarcaText = 'Foam, pressure and precision';
    var descrizioneBannerText = 'A leading company that for over 30 years has been a reference in the design and production of professional components and accessories for pressure washers and car washes.';
    var btnBannerText = 'Discover MTM Hydro products';
    var btnBannerUrl = '/en/collections/mtm-hydro';
    }
}
else if(getVendorText === 'Seko'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/Seko.jpg?v=1664988219';
    var logoMarcaText = 'Performance costante, sicurezza garantita';
    var titoloBannerText = 'SEKO';
    var descrizioneBannerText = "SEKO offre una gamma di prodotti ideali per il settore automotive, grazie ai sistemi a bassa e media pressione, in grado di adattarsi a qualsiasi applicazione, che consentono tempi di contatto prolungati e garantiscono una pulizia efficace e profonda. Produttore leader di pompe dosatrici e soluzione di misurazione";
    var btnBannerText = 'VEDI I PRODOTTI SEKO';
    var btnBannerUrl = '/collections/seko';
    if(lang == 'en'){
    var logoMarcaText = 'Consistent performance, guaranteed safety';
    var descrizioneBannerText = 'Seko offers a wide range of products ideal for the automotive sector, thanks to its low and medium pressure systems that adapt to any application. They allow for extended contact times and ensure deep, effective cleaning. Seko is a leading manufacturer of dosing pumps and measurement solutions.';
    var btnBannerText = 'Discover SEKO products';
    var btnBannerUrl = '/en/collections/seko';
    }
}
else if(getVendorText === 'STI'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/STI_Steam_Industry.jpg?v=1664988284';
    var logoMarcaText = 'La forza del vapore al servizio del professionista';
    var titoloBannerText = 'STI';
    var descrizioneBannerText = 'STI è leader nella realizzazione di macchine per la pulizia a vapore professionale. I prodotti sono interamente progettati e realizzati nello stabilimento di Fara Vicentino (VI) da personale altamente qualificato.';
    var btnBannerText = 'VEDI I PRODOTTI STI';
    var btnBannerUrl = '/collections/sti';
        if(lang == 'en'){
    var logoMarcaText = 'Steam power at the service of the professional';
    var descrizioneBannerText = 'STI is a leading manufacturer of professional steam cleaning machines. All products are entirely designed and built at the Fara Vicentino (VI) facility by highly qualified personnel.';
    var btnBannerText = 'Discover STI products';
    var btnBannerUrl = '/en/collections/sti';
    }
}
else if(getVendorText === 'Detail Guardz'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0660/5252/2209/files/Detailz_Guardz.jpg?v=1664988361';
    var logoMarcaText = 'Proteggi il tuo lavoro';
    var titoloBannerText = 'DETAIL GUARDZ';
    var descrizioneBannerText = "Detail Guardz è un'azienda che progetta, produce e spedisce direttamente dalla propria fabbrica in Canada assicurando standard qualitativi elevatissimi. L'unico obbiettivo di Detail Guardz è quello di proporre articoli che semplifichino la vita dei detailers e degli appassionati.";
    var btnBannerText = 'VEDI I PRODOTTI DETAIL GUARDZ';
    var btnBannerUrl = '/collections/detail-guarz';
    if(lang == 'en'){
    var logoMarcaText = 'Protect your work';
    var descrizioneBannerText = 'Detail Guardz is a company that designs, manufactures, and ships directly from its factory in Canada, ensuring the highest quality standards. The sole aim of Detail Guardz is to offer products that make life easier for detailers and enthusiasts.';
    var btnBannerText = 'Discover DETAIL GUARDZ products';
    var btnBannerUrl = '/en/collections/detail-guarz';
    }
}
else if(getVendorText === 'FOEN'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/FOEN.jpg?v=1689676117';
    var logoMarcaText = 'Una fragranza che ispira';
    var titoloBannerText = 'FOEN';
    var descrizioneBannerText = "FOEN® è il marchio polacco specializzato nella produzione di profumi di altissima qualità per gli interni dei veicoli. Le fragranze sono caratterizzate da longevità, da un’ampia scelta e da una delicatezza che rimane impressa.";
    var btnBannerText = 'VEDI I PRODOTTI FOEN';
    var btnBannerUrl = '/collections/foen';
    if(lang == 'en'){
    var logoMarcaText = 'A fragrance that inspires';
    var descrizioneBannerText = 'FOEN is a Polish brand specialized in producing premium-quality fragrances for vehicle interiors. The scents are known for their longevity, wide variety, and a subtle elegance that leaves a lasting impression.';
    var btnBannerText = 'Discover FOEN products';
    var btnBannerUrl = '/en/collections/foen';
    }
}
else if(getVendorText === 'CHAMALEON'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/CHAMALEON.jpg?v=1689676118';
    var logoMarcaText = 'Per un refinish di qualità';
    var titoloBannerText = 'CHAMALEON';
    var descrizioneBannerText = "CHAMALEON® è il marchio tedesco che propone prodotti di alta qualità per il Car Refinish, ossia per la riparazione professionale della carrozzeria.";
    var btnBannerText = 'VEDI I PRODOTTI CHAMALEON';
    var btnBannerUrl = '/collections/chamaleon';
    if(lang == 'en'){
    var logoMarcaText = 'For a high quality refinish';
    var descrizioneBannerText = 'CHAMALEON is a German brand that offers high-quality products for Car Refinish, i.e., professional bodywork repair.';
    var btnBannerText = 'Discover CHAMALEON products';
    var btnBannerUrl = '/en/collections/chamaleon';
    }
}
else if(getVendorText === 'BRÜHL DRYER'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/Br_hl_Dryer.jpg?v=1705399510';
    var logoMarcaText = 'Zero contatto, massima protezione';
    var titoloBannerText = 'BRÜHL DRYER';
    var descrizioneBannerText = "Soffiatori efficienti, perfetti per dare al tuo veicolo un'asciugatura professionale e senza contatto in pochissimi minuti.";
    var btnBannerText = 'VEDI I PRODOTTI BRÜHL DRYER';
    var btnBannerUrl = '/collections/bruhl-dryer';
        if(lang == 'en'){
    var logoMarcaText = 'Zero contact, maximum protection';
    var descrizioneBannerText = 'Brühl Dryer offers efficient blowers, perfect for giving your vehicle a professional, contactless drying in just a few minutes.';
    var btnBannerText = 'Discover BRÜHL DRYER products';
    var btnBannerUrl = '/en/collections/bruhl-dryer';
    }
}
else if(getVendorText === 'Sibelum'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/Sibelum.jpg?v=1705399944';
    var logoMarcaText = 'Precisione, qualità e lunga durata';
    var titoloBannerText = 'SIBELUM';
    var descrizioneBannerText = "SIBELUM azienda specializzata nella lavorazione del legno e delle setole naturali, che dà vita ad accessori di altissima qualità e caratterizzati da una durata incredibile.";
    var btnBannerText = 'VEDI I PRODOTTI SIBELUM';
    var btnBannerUrl = '/collections/sibelum';
        if(lang == 'en'){
    var logoMarcaText = 'Precision, quality and long life';
    var descrizioneBannerText = 'SIBELUM is a company specialized in working with wood and natural bristles, creating top-quality accessories known for their exceptional durability and distinctive craftsmanship.';
    var btnBannerText = 'Discover SIBELUM products';
    var btnBannerUrl = '/en/collections/sibelum';
    }
}
else if(getVendorText === 'KRANZLE'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/Kranzle.jpg?v=1715674099';
    var logoMarcaText = 'Dove potenza e controllo si incontrano';
    var titoloBannerText = 'KRANZLE';
    var descrizioneBannerText = "Leader mondiale della qualità nel settore delle idropulitrici, fin dall’inizio Kränzle ha attribuito grande importanza alla massima qualità dei materiali e dei componenti facendone lo standard del marchio, senza compromessi.";
    var btnBannerText = 'VEDI I PRODOTTI KRANZLE';
    var btnBannerUrl = '/collections/kranzle';
        if(lang == 'en'){
    var logoMarcaText = 'Where power and control meet';
    var descrizioneBannerText = 'A global leader in pressure washer quality, KRÄNZLE has always prioritized top-tier materials and components—setting the brand’s uncompromising standard from the very beginning.';
    var btnBannerText = 'Discover KRÄNZLE products';
    var btnBannerUrl = '/en/collections/kranzle';
    }
}
else if(getVendorText === 'Santoemma'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/Santoemma.jpg?v=1718954589';
    var logoMarcaText = 'Macchine professionali a iniezione-estrazione';
    var titoloBannerText = 'SANTOEMMA';
    var descrizioneBannerText = "Scopri le macchine Santoemma, progettate per offrire efficienza, affidabilità e lunga durata. La gamma CAR Wash propone soluzioni avanzate per la pulizia professionale di sedili e interni auto, rimuovendo completamente lo sporco e lasciando le superfici rapidamente asciutte.";
    var btnBannerText = 'VEDI I PRODOTTI SANTOEMMA';
    var btnBannerUrl = '/collections/santoemma';
        if(lang == 'en'){
    var logoMarcaText = 'Professional injection-extraction machines';
    var descrizioneBannerText = 'Discover Santoemma machines, designed to deliver efficiency, reliability, and durability. The CAR Wash range offers advanced solutions for professional cleaning of car seats and interiors, thoroughly removing dirt and leaving surfaces quickly dry.';
    var btnBannerText = 'Discover SANTOEMMA products';
    var btnBannerUrl = '/en/collections/santoemma';
    }
}
else if(getVendorText === 'THE FINISHER'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/The_Finisher.jpg?v=1763561361';
    var logoMarcaText = 'Preparazione e finitura di auto e imbarcazioni';
    var titoloBannerText = 'THE FINISHER by KCX';
    var descrizioneBannerText = "THE FINISHER è la scelta ideale nella preparazione e finitura di auto e imbarcazioni per l'appassionato. Potenza, precisione e l'esperienza Koch-Chemie si uniscono per offrire prodotti ad alte prestazioni e risultati impeccabili.";
    var btnBannerText = 'VEDI I PRODOTTI THE FINISHER by KCX';
    var btnBannerUrl = '/collections/the-finisher-by-kcx';
        if(lang == 'en'){
    var logoMarcaText = 'Preparing and finishing cars and boats';
    var descrizioneBannerText = 'THE FINISHER is the ideal choice for the enthusiast in preparing and finishing cars and boats. Power, precision, and Koch-Chemie experience combine to offer high-performance products and flawless results.';
    var btnBannerText = 'Discover THE FINISHER by KCX products';
    var btnBannerUrl = '/en//collections/the-finisher-by-kcx';
    }
}
else if(getVendorText === 'KIURLAB'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/KiurLab.jpg?v=1765790875';
    var logoMarcaText = 'Prestazioni reali e formule avanzate per il car detailing';
    var titoloBannerText = 'KIURLAB';
    var descrizioneBannerText = "KiurLab nasce come centro di ricerca specializzato nello sviluppo di soluzioni avanzate per il car care e il detailing. Il brand sviluppa e produce internamente formule avanzate ad alte prestazioni, pensate per garantire risultati professionali.";
    var btnBannerText = 'VEDI I PRODOTTI KIURLAB';
    var btnBannerUrl = '/collections/kiurlab';
        if(lang == 'en'){
    var logoMarcaText = 'Real performance and advanced formulas for car detailing';
    var descrizioneBannerText = 'KiurLab was founded as a research center specializing in the development of advanced solutions for car care and detailing. The brand develops and produces advanced, high-performance formulas in-house, designed to guarantee professional results..';
    var btnBannerText = 'Discover KIURLAB products';
    var btnBannerUrl = '/en/collections/kiurlab';
    }
}

else if(getVendorText === 'YumCars'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/Yumcars.jpg?v=1769675404';
    var logoMarcaText = 'CREATO DAI DETAILER, PER I DETAILER';
    var titoloBannerText = 'YUMCARS';
    var descrizioneBannerText = "YumCars nasce nel Regno Unito dal'esperienza diretta e dalla passione per il detailing, con l'obiettivo di creare prodotti per il car care senza compromessi.";
    var btnBannerText = 'VEDI I PRODOTTI YUMCARS';
    var btnBannerUrl = '/collections/yumcars';
        if(lang == 'en'){
    var logoMarcaText = 'DESIGNED BY DETAILERS FOR DETAILERS';
    var descrizioneBannerText = 'YumCars was born in the UK from first-hand experience and a passion for detailing, with the aim of creating uncompromising car care products.';
    var btnBannerText = 'Discover YUMCARS products';
    var btnBannerUrl = '/en/collections/yumcars';
    }
}

else if(getVendorText === 'SCHOLL CONCEPTS'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/Scholl_Concept_430x.jpg';
    var logoMarcaText = 'THE SCIENCE OF GLOSS';
    var titoloBannerText = 'SCHOLL CONCEPTS';
    var descrizioneBannerText = "";
    var btnBannerText = 'VEDI I PRODOTTI SCHOLL CONCEPTS';
    var btnBannerUrl = '/collections/scholl-concepts';
        if(lang == 'en'){
    var logoMarcaText = 'THE SCIENCE OF GLOSS';
    var descrizioneBannerText = '';
    var btnBannerText = 'Discover SCHOLL CONCEPTS products';
    var btnBannerUrl = '/collections/scholl-concepts';
    }
}

else if(getVendorText === 'Vikan'){
    var imgBannerUrl = 'https://cdn.shopify.com/s/files/1/0602/0975/8437/files/Vikan.jpg?v=1720427744';
    var logoMarcaText = 'Professionali su ogni superficie';
    var titoloBannerText = 'VIKAN';
    var descrizioneBannerText = "Vikan è un'azienda leader che offre un'ampia gamma di attrezzature per la pulizia dei veicoli, garantendo standard igienici elevati. Manici e impugnature hanno forme ergonomiche che consentono di pulire con maggiore efficienza e senza sforzi.";
    var btnBannerText = 'VEDI I PRODOTTI VIKAN';
    var btnBannerUrl = '/collections/vikan';
        if(lang == 'en'){
    var logoMarcaText = 'Professional on every surface';
    var descrizioneBannerText = 'Vikan is a leading company offering a wide range of equipment for vehicle cleaning, ensuring high hygiene standards. Handles and grips feature ergonomic shapes that allow for more efficient and effortless cleaning.';
    var btnBannerText = 'Discover VIKAN products';
    var btnBannerUrl = '/en/collections/vikan';
    }
}
else {
    var imgBannerUrl = '';
    var logoMarcaText = '';
    var titoloBannerText = '';
    var descrizioneBannerText = '';
    var btnBannerText = '';
    var btnBannerUrl = '';
}
}
const hookBanner = document.querySelector('#product-custom #shopify-section-static-text-with-icons');
const htmlBanner = `<section id="brand_cta">
          <div class="container">
            <div class="cont_banner">
              <img src="`+ imgBannerUrl +`" alt="`+ descrizioneBannerText +`">
            </div>
            <div class="cont_testo">
              <div class="brand">`+ logoMarcaText +`</div>
              <h2>`+ titoloBannerText +`</h2>
              <p>`+ descrizioneBannerText +`</p>
              <a href="`+ btnBannerUrl +`" class="button button--primary">`+ btnBannerText +`</a>
            </div>
          </div>
        </section>`;

if(hookBanner && imgBannerUrl){
  hookBanner.insertAdjacentHTML('beforebegin', htmlBanner);
}
//banner dimanico___END

});